import React from 'react';

export const ConfirmModal = ({ isVisible, onConfirm, onCancel, title, message }) => {
    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 m-4 w-full max-w-sm">
                {title && (
                    <h3 className="text-lg font-semibold mb-4 text-center text-gray-900">{title}</h3>
                )}
                <div className="mb-6 text-center text-gray-700 leading-relaxed whitespace-pre-wrap">
                    {message}
                </div>
                <div className="flex justify-center space-x-3">
                    <button
                        onClick={onCancel}
                        className="w-1/2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg active:bg-gray-200 font-medium"
                    >
                        취소
                    </button>
                    <button
                        onClick={onConfirm}
                        className="w-1/2 px-6 py-3 bg-amber-500 text-white rounded-lg active:bg-amber-600 font-medium"
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
};
